export const FAQS = [
  {
    cat: "Plans",
    q: "What's included in each plan?",
    a: "Every plan includes kiln-dried logs, kindling and firelighters. Starter has 2 bags of logs, Regular has 4 and Family has 6. See Our Plans for full contents.",
  },
  {
    cat: "Plans",
    q: "Can I get a custom plan?",
    a: "Yes. If none of our plans fit, get in touch and tell us what you need. We'll agree a monthly price and give you a personal code to enter on Our Plans to sign up. You can also add our smokeless coal to a custom plan.",
  },
  {
    cat: "Plans",
    q: "Do you sell coal?",
    a: "Yes. We sell 20kg bags of smokeless coal for £12 a bag, added to a custom plan. Get in touch to tell us how many bags you'd like each month.",
  },
  {
    cat: "Plans",
    q: "What are kiln-dried logs?",
    a: "Kiln-dried logs have been dried in a kiln to reduce their moisture content, which helps them light easily, burn hotter and produce less smoke than damp wood.",
  },
  {
    cat: "Delivery",
    q: "Where do you deliver?",
    a: "We currently deliver to BT36, BT37, BT38 and BT39. Enter your full postcode on our Delivery Areas page to check. If we don't cover you yet, you can join the waiting list.",
  },
  {
    cat: "Delivery",
    q: "When will my logs arrive?",
    a: "Deliveries are planned by area. Once your subscription is set up we'll confirm your delivery day by email, and you'll see your next planned delivery in My WeeLogRun.",
  },
  {
    cat: "Delivery",
    q: "Do I need to be home?",
    a: "Not necessarily. Add delivery instructions at checkout — for example where to leave your logs — and you can update them any time in My WeeLogRun.",
  },
  {
    cat: "Your subscription",
    q: "Can I pause my subscription?",
    a: "Yes. Pause for 1, 2 or 3 months from My WeeLogRun. You'll see your pause and resume dates before you confirm, you won't be charged while paused, and your plan resumes automatically.",
  },
  {
    cat: "Your subscription",
    q: "Can I skip a delivery?",
    a: "Yes. You can skip your next upcoming delivery and you won't be charged for it. Your billing and delivery dates move on together.",
  },
  {
    cat: "Your subscription",
    q: "Can I change my plan?",
    a: "Yes. Upgrade or downgrade between Starter, Regular and Family at any time. We'll show you the new price and when it takes effect before you confirm.",
  },
  {
    cat: "Your subscription",
    q: "How do I cancel?",
    a: "Cancel online from My WeeLogRun — no phone calls or emails needed. We'll show you the date it takes effect and confirm by email. See our Subscription & Cancellation Policy for full details.",
  },
  {
    cat: "Account & payments",
    q: "Do I need to create a password?",
    a: "Yes. You choose a password when you join, then sign in to My WeeLogRun with your email and password. If you forget it, we'll email you a secure link to set a new one.",
  },
  {
    cat: "Account & payments",
    q: "How do payments work?",
    a: "Payments are taken securely on Stripe's payment page. Your first payment is taken when you subscribe, then automatically each month on the same date. We never see or store your card details. If a payment fails, we'll email you a secure link to pay.",
  },
];
